import { oauth2Instance } from '../../../common/services';

/**
 * Track grievance using Case ID (SRN)
 * Matches backend CURL exactly
 */
export async function trackGrievanceBySRN(caseId) {
  const baseHeaders = await oauth2Instance.getHeaders();

  const headers = {
    ...baseHeaders,
    Messageid: '123456_',
    Payloadkey: 'Payloadkey',
    Payloadname: 'EmailCaseCombinedDetailsByCaseId',
    Servicename: 'CaseDetail',
    Sourceapplicationname: 'website',
    PageSourceName:'write-to-us',
    'Content-Type': 'application/json'
  };

  const response = await fetch(
    `${oauth2Instance.getPortalURL()}/o/sclservices/grievanceapi/emailcasedetailsbycaseid?caseid=${encodeURIComponent(caseId)}`,
    {
      method: 'GET',
      headers
    }	
  );

  if (!response.ok) {
    throw new Error('Invalid Service Request Number');
  }

  return response.json();
}
